import { Message } from 'element-ui';

// 获取当天开始时间戳
export const getTodayStartTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date.getTime();
};
// 获取当天末尾时间戳
export const getTodayEndTimestamp = () => {
  const date = new Date();
  // date.setHours(23);
  // date.setMinutes(59);
  // date.setSeconds(59);
  // date.setMilliseconds(59);
  return date.getTime();
};
export const getTodayEndTimestampLast = () => {
  const date = new Date();
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(59);
  return date.getTime();
};
// 获取七天前开始时间戳
export const getSevenTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
  return date.getTime();
};
// 获取30天前开始时间戳
export const getThirtyTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
  return date.getTime();
};


// 将时间戳转换成时间
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : `0${n}`;
}


export const formatDate = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  // const hour = formatNumber(now.getHours());
  // const minute = formatNumber(now.getMinutes());
  // const second = formatNumber(now.getSeconds());
  return `${year}-${month}-${date}`;
};

export const formatDatehour = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  const hour = formatNumber(now.getHours());
  const minute = formatNumber(now.getMinutes());
  const second = formatNumber(now.getSeconds());
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
};

export const formatDateEndhour = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  return `${year}-${month}-${date} 23:59:59`;
};

// 获得某月的天数
const getMonthDays = (year, month) => {
  // 本月第一天 1-31
  const relativeDate = new Date(year, month, 1);
  // 获得当前月份0-11
  let relativeMonth = relativeDate.getMonth();
  // 获得当前年份4位年
  let relativeYear = relativeDate.getFullYear();

  // 当为12月的时候年份需要加1 月份需要更新为0 也就是下一年的第一个月
  if (relativeMonth === 11) {
    relativeYear += 1;
    relativeMonth = 0;
  } else {
    // 否则只是月份增加,以便求的下一月的第一天
    relativeMonth += 1;
  }
  // 一天的毫秒数
  const millisecond = 1000 * 60 * 60 * 24;
  // 下月的第一天
  const nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
  // 返回得到上月的最后一天,也就是本月总天数
  return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
};
// 返回上一个月的第一天Date类型
const getPriorMonthFirstDay = (year, month) => {
  // 年份为0代表,是本年的第一月,所以不能减
  if (month === 0) {
    return new Date(year - 1, 11, 1);
  }
  // 否则,只减去月份
  return new Date(year, month - 1, 1);
};

// 获取上一周的方法
export const getLastWeek = () => {
  const result = {
    startDate: null,
    endDate: null,
  };
  const day = new Date();// 获取当前时间
  const week = day.getDay();
  const millisecond = 1000 * 60 * 60 * 24; // 一天的毫秒数
  const minusDay = week !== 0 ? week - 1 : 6; // 减去的天数
  // 获得当前周的第一天
  const currentWeekDayOne = new Date(day.getTime() - (millisecond * minusDay));
  // 上周最后一天即本周开始的前一天
  const priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
  priorWeekLastDay.setHours(23);
  priorWeekLastDay.setMinutes(59);
  priorWeekLastDay.setSeconds(59);
  priorWeekLastDay.setMilliseconds(59);

  // 上周的第一天
  const priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));
  priorWeekFirstDay.setHours(0);
  priorWeekFirstDay.setMinutes(0);
  priorWeekFirstDay.setSeconds(0);
  priorWeekFirstDay.setMilliseconds(0);

  result.startDate = priorWeekFirstDay;
  result.endDate = priorWeekLastDay;
  return result;
};
// 获取上一月的方法
export const getLastMonth = () => {
  const result = {
    startDate: null,
    endDate: null,
  };
  const day = new Date();
  // 获得当前月份0-11
  const currentMonth = day.getMonth();
  // 获得当前年份4位年
  const currentYear = day.getFullYear();
  // 获得上一个月的第一天
  const priorMonthFirstDay = getPriorMonthFirstDay(currentYear, currentMonth);
  priorMonthFirstDay.setHours(0);
  priorMonthFirstDay.setMinutes(0);
  priorMonthFirstDay.setSeconds(0);
  priorMonthFirstDay.setMilliseconds(0);

  // 获得上一月的最后一天
  const priorMonthLastDay = new Date(priorMonthFirstDay.getFullYear(),
    priorMonthFirstDay.getMonth(),
    getMonthDays(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()));
  priorMonthLastDay.setHours(23);
  priorMonthLastDay.setMinutes(59);
  priorMonthLastDay.setSeconds(59);
  priorMonthLastDay.setMilliseconds(59);

  result.startDate = priorMonthFirstDay;
  result.endDate = priorMonthLastDay;
  return result;
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  return (...args) => {
    const context = this;
    if (timeout) clearTimeout(timeout);

    if (immediate) {
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
};
export const downLoadFileByForm = (url, obj) => {
  const tempForm = document.createElement("form");
  tempForm.name = "myform";
  tempForm.id = "myform";
  tempForm.action = url;
  tempForm.method = "post";
  tempForm.target = "form";
  tempForm.style.display = "none";
  const keys = Object.keys(obj);
  keys.forEach((key) => {
    const opt = document.createElement("input");
    opt.name = key;
    opt.value = obj[key];
    if (key === "pageSize") opt.value = 10;
    if (opt.value !== "") {
      tempForm.appendChild(opt);
    }
  });
  const opt = document.createElement("button");
  opt.type = "submit";
  opt.id = "submit";
  tempForm.appendChild(opt);
  document.body.appendChild(tempForm);

  const iframe = document.createElement("iframe");
  iframe.name = "form";
  iframe.id = "jForm";
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  opt.click();
  document.querySelector('#jForm').addEventListener('load', () => {
    const content = document.querySelector('#jForm').contentDocument && document.querySelector('#jForm').contentDocument.body.innerHTML;
    if (content) {
      Message({
        showClose: true,
        message: content.split(',')[1].split(":")[1].replace(/"/g, ''),
        type: "error",
      });
    }
    document.body.removeChild(tempForm);
    document.body.removeChild(iframe);
  });
};

export const userLoginError = (code) => {
  let msg;
  switch (code) {
    case 10003: {
      msg = '用户不存在或者密码错误';
      break;
    }
    case 10005: {
      msg = '验证码不正确';
      break;
    }
    case 10009: {
      msg = '用户账号已被冻结';
      break;
    }
    case 10021: {
      msg = '登录发生风险，请30分钟后重试';
      break;
    }
    case 10022:
    case 10062: {
      msg = '图形验证码校验不正确';
      break;
    }
    case 10061: {
      msg = '需要图形验证码';
      break;
    }
    case 10063: {
      msg = '发送短信失败';
      break;
    }
    case 10060: {
      msg = '获取验证码错误';
      break;
    }
    case 10041: {
      msg = '退出登录失败';
      break;
    }
    case 10502: {
      msg = '旧密码和新密码不能相同';
      break;
    }
    default: {
      msg = '系统繁忙稍后重试';
    }
  }
  return msg;
};
// 8-20位大小写字母、数字、符号中的至少三种组合登录密码
export function validStrictPsd(str) {
  const reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)[^\u4e00-\u9fa5\s]{8,20}$/;
  return reg.test(str);
}

export const strictPsdError = '密码为8-20位大小写字母/数字/符号中的至少三种组合';

export function sToFixed(v, n = 2) {
  if (typeof v === 'number' || !Number.isNaN(parseFloat(v))) {
    return parseFloat(v).toFixed(n);
  }
  return '0.00';
}

/**
 * 通过非跨域链接下载图片
 * @param {String} url 图片下载链接
 * @param {String} imgName 下载图片名称（非必填，仅downloadImgByCrossOriginUrl调用传入）
 */
export function downloadImg(url, imgName) {
  const imageName = imgName || url.split('/').slice(-1)[0];
  const link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('download', imageName);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * 通过跨域链接下载图片（需服务器设置允许跨域）
 * @param {String} url 图片下载链接
 */
export function downloadImgByCrossOriginUrl(url) {
  const image = new Image(); // 创建图片对象
  const imageName = url.split('/').slice(-1)[0];
  image.setAttribute('crossorigin', 'anonymous'); // 设置允许跨域
  image.src = `${url}?timestamp= ${Date.now()}`; // 赋值src
  image.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, image.width, image.height);
    const ext = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
    const dataURL = canvas.toDataURL(`image/'${ext}`);
    downloadImg(dataURL, imageName);
  };
}
export function getUrlParams(url = window.location.href) {
  // 创建一个对象来存储参数
  const paramsObj = {};

  // 找到 '?' 之后的查询字符串部分
  const queryString = url.split('?')[1];

  // 如果没有查询字符串，返回空对象
  if (!queryString) {
    return paramsObj;
  }

  // 将查询字符串按 '&' 分割成键值对
  const pairs = queryString.split('&');

  // 遍历所有键值对
  for (const pair of pairs) {
    // 分割成键和值
    const [key, value] = pair.split('=');

    // 解码并添加到对象中
    paramsObj[decodeURIComponent(key)] = decodeURIComponent(value || '');
  }

  return paramsObj;
}
